<template>
  <details-sheet :item="subscription" :headers="headers" v-bind="$attrs">
    <template v-slot:item.customer="{ item }">
      <span>{{ name }}</span>
      <v-btn v-if="item.person" class="float-right" small icon :to="to">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>

    <template v-slot:item.address="{ item }">
      {{ address }}
    </template>
  </details-sheet>
</template>

<script>
import DetailsSheet from '@/modules/_global/_components/DetailsSheet.vue';

export default {
  name: 'SubscriptionDetail',

  components: {
    DetailsSheet
  },

  props: {
    subscription: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('ORDERS.CUSTOMER'),
          value: 'customer'
        },
        {
          text: this.$t('ITEM.ADDRESS'),
          value: 'address'
        },
        {
          text: this.$t('PROFILE.MOBILE_PHONE'),
          value: 'person.personal_profile.mobile_phone'
        },
        {
          text: this.$t('PROFILE.PHONE'),
          value: 'person.personal_profile.phone'
        },
        {
          text: this.$t('PROFILE.EMAIL'),
          value: 'person.user.email'
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          value: 'person.inhabitant.apartment.building.building_complex.name'
        },
        {
          text: this.$t('ABO_SERVICES.ITEM'),
          value: 'service.title'
        },
      ];
    },

    name() {
      if (!this.subscription.person) {
        return '';
      }

      const { first_name = '', last_name = '' } = this.subscription.person;

      return `${first_name} ${last_name}`.trim();
    },

    address() {
      if (
        !this.subscription.person ||
        !this.subscription.person.personal_profile
      ) {
        return '';
      }

      const street = this.subscription.person.personal_profile.street || '';
      const zip = this.subscription.person.personal_profile.zip || '';
      const city = this.subscription.person.personal_profile.city || '';

      return `${street}, ${zip} ${city}`.replace(/^[\s,]+|[\s,]+$/g, '');
    },

    to() {
      return {
        name: 'persons.show',
        params: { id: this.subscription.person.id }
      };
    }
  }
};
</script>
